import { Component, ElementRef, HostBinding, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'ce-spinning-loader, ce-spinning-loader-lg, ce-spinning-loader-sm',
    imports: [CommonModule],
    templateUrl: './ce-spinning-loader.component.html',
    styleUrl: './ce-spinning-loader.component.scss'
})
export class CeSpinningLoaderComponent implements OnInit {
    loaderSizes: string[] = ['ce-spinning-loader-sm', 'ce-spinning-loader-lg'];
    selectedLoaderSize: string = 'ce-spinning-loader-sm';

    @HostBinding('class') get className(): string {
        const size = this.selectedLoaderSize.split('-').pop();
        return `CeSpinningLoader CeSpinningLoader--${size}`;
    }

    constructor(private elRef: ElementRef) {}

    ngOnInit(): void {
        const spinnerElement = this.elRef.nativeElement as HTMLElement;

        for (const size of this.loaderSizes) {
            if (spinnerElement.hasAttribute(size)) {
                this.selectedLoaderSize = size;
                break;
            }
        }
    }
}
